import { Navigate, useParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import MatchesPage from "@/pages/MatchesPage";

/**
 * `/c/[slug]` — the "home" for a client's environment.
 *
 * - Unauthenticated visitors are sent to the bare-slug branded login/
 *   register experience at `/[slug]` (mounts SluggedLoginPage). This is
 *   what someone scanning the QR / sharing the URL should hit — the
 *   pub's branded login card, not a stripped-down "Welcome to X" splash.
 * - Authenticated visitors see the same `MatchesPage` (Predictions) they
 *   see at `/`. Keeps the URL communicating which client environment
 *   they're inside so the slug-scoped header links stay meaningful.
 */
export default function ClientSlugHome() {
  const { user, bootstrapped } = useAuth();
  const { slug } = useParams();
  if (!bootstrapped) return null;
  if (!user) return <Navigate to={`/${slug}`} replace />;
  return <MatchesPage />;
}
